module.exports = __webpack_public_path__ + "static/Artboard-5-898d59480e6f5a2fd188f3335e3ba7cb.png";